import React, { Component, Fragment } from 'react';
import { isEmpty } from "lodash";
import { Grid, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Button, FormHelperText, Box } from '@mui/material';

import FileUpload from '../../common/FileUpload';
import DatePicker from '../../common/DatePicker';
import InputText, { InputSelectNative } from '../../common/Form';

class TransferForm extends Component {
    state = { 
        transfer_id: this.props.transfer ? this.props.transfer.transfer_id : "",
        transfer_desc: this.props.transfer ? this.props.transfer.transfer_desc : "",
        transfer_ref: this.props.transfer ? this.props.transfer.transfer_ref : "",
        transfer_payment_mode: this.props.transfer ? this.props.transfer.transfer_payment_mode : "",
        transfer_bank_src: this.props.transfer ? this.props.transfer.transfer_bank_src : "",
        transfer_bank_dest: this.props.transfer ? this.props.transfer.transfer_bank_dest : "",
        transfer_amount: this.props.transfer ? parseFloat(this.props.transfer.transfer_amount) : "",
        transfer_files: null,
        transfer_date: this.props.transfer ? this.props.transfer.transfer_date : new Date(),
        
        errors: {
            transfer_date: "",
            transfer_desc: "",
            transfer_ref: "",
            transfer_payment_mode: "",
            transfer_bank_src: "",
            transfer_bank_dest: "",
            transfer_amount: "",
            transfer_files: "",
        },
        available: ""
    }

    handleChange = (e) => {
        const { name, value} = e.target;
        
        this.setState({
            [name]: value
        })        
    }

    handleChangeDate = (date) => {
        this.setState({
            transfer_date: date
        })
    }
    handleChangeSelect = (option, name) => {
        if(option){
            this.setState({
                [name]: option
            })
        } else {
            this.setState({
                [name]: {}
            })
        }
    }
    createNew = (field, name) => {
        this.setState({
            [field]: true,
            nameNew: name
        })
    }
    setFiles = (transfer_files, error = "") => {
        console.log("[INFO] SET_PHOTO", transfer_files);
        this.setState({
            transfer_files,
            errors:{
                ...this.state.errors,
                transfer_files:error
            }
        })
    }
    validate = () => {
        let required = [
            "transfer_amount",
            "transfer_ref",
            "transfer_desc",
            "transfer_payment_mode",
            "transfer_bank_src",
            "transfer_bank_dest",
            "transfer_files"
        ]
        if (this.props.update){
            required = [
                "transfer_amount",
                "transfer_ref",
                "transfer_desc",
                "transfer_payment_mode",
                "transfer_bank_src",
                "transfer_bank_dest",
            ]
        }
        
        let noError = true
        let errors = {}
        
        required.map(field => {
            if( isEmpty(this.state[field]) && !this.state[field] ) { // isEmpty doesn't work on dates, !doesn't work for arrays
                console.log(`${field} is empty`)
                noError =  false
                errors[field] = "Veuillez remplir ce Champ" 
            } else {
                errors[field] = "" 
            }
        })

        
        this.setState({
            errors
        })
        
        return noError
    }
    handleSubmit = async () => {

        if( this.validate() ){
            let data = {}
            if(this.props.update){
                data = Object.assign({}, this.props.transfer)
            } else {
                data.transfer_files =  this.state.transfer_files
            }
            data.transfer_amount =  parseFloat(this.state.transfer_amount)
            data.transfer_payment_mode = this.state.transfer_payment_mode
            data.transfer_bank_src =  this.state.transfer_bank_src
            data.transfer_bank_dest =  this.state.transfer_bank_dest
            data.transfer_ref =  this.state.transfer_ref
            data.transfer_date =  this.state.transfer_date
            data.transfer_desc =  this.state.transfer_desc
            
            
            console.log('====================================');
            console.log("submit transfer", {data});
            console.log('====================================');
            
            if (this.props.update) {
                await this.props.updateTransfer(data)
            } else {
                await this.props.newTransfer(data)
            }

            // // if NoErrors ...
            if(this.props.STATE.transfers.error){
                this.props.notif("error",`Un problème est survenu: ${this.props.STATE.transfers.error}`)
            } else { 
                this.props.notif("success", "Enregistré")
                this.props.handleClose()
            }
        } else {
            this.props.notif("error", "Le formulaire contient des erreurs")
        }
    }
    
    render() {
        const { BANKS, POSTS, STATE } = this.props;
        const { nameNew, formPost} = this.state;
        console.log('====================================');
        console.log(this.state);
        console.log('====================================');
        return (
            <Dialog
                open={true}
                onClose={this.props.handleClose}
                aria-labelledby="form-dialog-title"
                fullWidth
                maxWidth= "lg"
                scroll="body">
                <DialogTitle id="form-dialog-title">Nouveau Transfert de Fonds</DialogTitle>
                <DialogContent>
                    <Grid container >
                        <Grid sm={6} xs ={12}>
                            <DatePicker  
                                id="transfer_date" 
                                label="Date" 
                                name="transfer_date" 
                                value={this.state.transfer_date} 
                                handleChange={this.handleChangeDate} 
                                error={this.state.errors.transfer_date}
                                required
                            />      
                            <InputSelectNative
                                label="Banque Source"
                                onChange={this.handleChange}
                                labelWidth={150} 
                                error={this.state.errors.transfer_bank_src}
                                value={this.state.transfer_bank_src}
                                name="transfer_bank_src" 
                                id="transfer_bank_src" 
                                options={ Object.values(BANKS).map( bank  => (
                                    <option 
                                        value={bank.bank_id} 
                                        key={bank.bank_id} 
                                        disabled={this.state.transfer_bank_src === bank.bank_id || this.state.transfer_bank_dest === bank.bank_id} 
                                    >
                                        {bank.bank_name}
                                    </option>
                                )) }
                            />
                            <InputSelectNative
                                label="Banque Destinataire"
                                onChange={this.handleChange}
                                labelWidth={180} 
                                error={this.state.errors.transfer_bank_dest}
                                value={this.state.transfer_bank_dest}
                                name="transfer_bank_dest" 
                                id="transfer_bank_dest" 
                                options={ Object.values(BANKS).map( bank  => (
                                    <option 
                                        value={bank.bank_id} 
                                        key={bank.bank_id} 
                                        disabled={this.state.transfer_bank_src === bank.bank_id || this.state.transfer_bank_dest === bank.bank_id} 
                                    >
                                        {bank.bank_name}
                                    </option>
                                )) }
                            />
                            <InputSelectNative
                                label="Mode de Paiement"
                                value={this.state.transfer_payment_mode}
                                onChange={this.handleChange}
                                labelWidth={170} 
                                name="transfer_payment_mode" id="transfer_payment_mode"
                                error={this.state.errors.transfer_payment_mode} 
                                options={[
                                    <option value="ESPECES">ESPECES</option>,
                                    <option value="CHEQUE">CHEQUE</option>,
                                    <option value="PRELEVEMENT">PRELEVEMENT</option>,
                                    <option value="VIREMENT">VIREMENT</option>,
                                    <option value="GAB">GAB</option>,
                                    <option value="MOBILE MONEY">MOBILE MONEY</option>
                                ]}
                            />
                            
                            
                        </Grid>
                        <Grid sm={6} xs ={12}>
                            <InputText
                                onChange={this.handleChange}
                                required
                                id="transfer_desc"
                                error={this.state.errors.transfer_desc}
                                value={this.state.transfer_desc}
                                name="transfer_desc"
                                label="Description"
                                rows={5}
                                multiline
                            />
                            
                            <InputText
                                onChange={this.handleChange}
                                required
                                id="transfer_amount"
                                error={this.state.errors.transfer_amount}
                                value={this.state.transfer_amount}
                                name="transfer_amount"
                                label="Montant"
                                type="number"          
                            />
                            
                            <InputText
                                onChange={this.handleChange}
                                required
                                id="transfer_ref"
                                error={this.state.errors.transfer_ref}
                                value={this.state.transfer_ref}
                                name="transfer_ref"
                                label="Référence"
                            />
                        </Grid>
                    </Grid>
                    {!this.props.update &&
                        <Box p={1}>
                            <FileUpload
                                label="Ajouter un Justificatif"
                                setFiles={this.setFiles} 
                                files={this.state.transfer_files || []} 
                            />
                            <FormControl error={!!this.state.errors.transfer_files} >
                                <br/>
                                <FormHelperText >{this.state.errors.transfer_files}</FormHelperText>
                            </FormControl>
                        </Box>
                    }
                    
                    
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" onClick={this.handleSubmit} color="secondary">
                        Valider
                    </Button>
                    <Button onClick={this.props.handleClose}>
                        Annuler
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default TransferForm;